import { CIcon } from '~/icons/types'
export const ciCalendar: CIcon = {
  width: 512,
  height: 486,
  paths: [
    {
      d:
        'M462 35.7h-55.8V10.5c0-5.8-4.7-10.5-10.5-10.5s-10.5 4.7-10.5 10.5v25.2H126.8V10.5c0-5.8-4.7-10.5-10.5-10.5s-10.5 4.7-10.5 10.5v25.2H50c-27.6 0-50 22.4-50 50V436c0 27.6 22.4 50 50 50h412c27.6 0 50-22.4 50-50V85.7c0-27.7-22.4-50-50-50zM491 436c0 16-13 29-29 29H50c-16 0-29-13-29-29V150.1h470V436zm0-306.9H21V85.7c0-16 13-29 29-29h55.8v32.4c0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5V56.7h258.3v32.4c0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5V56.7H462c16 0 29 13 29 29v43.4z'
    },
    {
      d:
        'M96 278.4h59.8c8.5 0 15.5-7 15.5-15.5v-59.8c0-8.5-7-15.5-15.5-15.5H96c-8.5 0-15.5 7-15.5 15.5v59.8c0 8.6 7 15.5 15.5 15.5zm5.5-69.8h48.8v48.8h-48.8v-48.8z'
    },
    {
      d:
        'M226.1 278.4h59.8c8.5 0 15.5-7 15.5-15.5v-59.8c0-8.5-7-15.5-15.5-15.5h-59.8c-8.5 0-15.5 7-15.5 15.5v59.8c0 8.6 6.9 15.5 15.5 15.5zm5.5-69.8h48.8v48.8h-48.8v-48.8z'
    },
    {
      d:
        'M96 413.6h59.8c8.5 0 15.5-7 15.5-15.5v-59.8c0-8.5-7-15.5-15.5-15.5H96c-8.5 0-15.5 7-15.5 15.5v59.8c0 8.5 7 15.5 15.5 15.5zm5.5-69.9h48.8v48.8h-48.8v-48.8z'
    },
    {
      d:
        'M226.1 413.6h59.8c8.5 0 15.5-7 15.5-15.5v-59.8c0-8.5-7-15.5-15.5-15.5h-59.8c-8.5 0-15.5 7-15.5 15.5v59.8c0 8.5 6.9 15.5 15.5 15.5zm5.5-69.9h48.8v48.8h-48.8v-48.8z'
    },
    {
      d:
        'M416 322.7h-59.8c-8.5 0-15.5 7-15.5 15.5V398c0 8.5 7 15.5 15.5 15.5H416c8.5 0 15.5-7 15.5-15.5v-59.8c0-8.5-7-15.5-15.5-15.5zm-5.5 69.9h-48.8v-48.8h48.8v48.8z'
    },
    {
      d:
        'M369 272.1c.3.3.5.6.8.8l.3.3c.2.1.3.3.5.4.1.1.2.1.3.2.2.1.4.3.6.4.1.1.2.1.3.2l.6.3c.1 0 .2.1.3.1.6.3 1.3.5 1.9.6h.2c.3.1.5.1.8.1h.2c.3 0 .7.1 1 .1.4 0 .7 0 1.1-.1h.3c.3 0 .6-.1.8-.1.1 0 .2 0 .3-.1l.9-.3c.1 0 .1 0 .2-.1.4-.1.7-.3 1-.4.1 0 .1-.1.2-.1.2-.1.5-.3.7-.4.1-.1.2-.2.4-.2.2-.1.4-.3.6-.4.1-.1.2-.2.4-.3l.1-.1.4-.4.3-.3c.3-.3.5-.6.8-.9l49.3-67c3.4-4.7 2.4-11.2-2.2-14.7-4.7-3.4-11.2-2.4-14.7 2.2l-41.6 56.6-22.2-25c-3.9-4.3-10.5-4.7-14.8-.9-4.3 3.9-4.7 10.5-.9 14.8l30.8 34.7z'
    }
  ],
  name: 'calendar',
  type: 'regular'
}
